import React from "react";
import CertificationItem from "./CertificationItem";
import certificationData from "../Data/CertificationCourses.json"; // Asegúrate de importar el JSON correctamente
import circle from "../Assets/line_curly.png";


export const CoursesGroup = () => {
  return (
    <div className="courses">

      <div className="certification-cont"> 
    
  
        <div className="map">
            <h1 className="es">Courses </h1>
          {certificationData.courses.map((courses, index) => (
            <CertificationItem
              key={index}
              title={courses.title}
              provider={courses.provider}
              date={courses.date}
              description={courses.description}
            />
          ))}
        </div>
       <div className="form"> 
       
          <img src={circle} alt="icon" className="icon-curly" />
        </div>
      </div>
    </div>
  );
};